<script>
    import { navigateTo } from 'svelte-router-spa'
    import { sex } from '../../store.js'

    function nxt(mySex) {
        sex.set(mySex)
        navigateTo('residence')
    }
</script>

<main>
    <div class="body">
        <h1>Enter your sex</h1>
        <a class="btn" on:click={() => nxt('MALE')}>
            <span class="e">Male</span>
            <span class="f">Lalaki</span>
        </a>
        <a class="btn" on:click={() => nxt('FEMALE')}>
            <span class="e">Female</span>
            <span class="f">Babae</span>
        </a>
    </div>
</main>